"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessListEventType = void 0;
var AccessListEventType;
(function (AccessListEventType) {
    AccessListEventType["Blacklisted"] = "Blacklisted";
    AccessListEventType["UnBlacklisted"] = "UnBlacklisted";
    AccessListEventType["Whitelisted"] = "Whitelisted";
    AccessListEventType["UnWhitelisted"] = "UnWhitelisted";
})(AccessListEventType || (exports.AccessListEventType = AccessListEventType = {}));
//# sourceMappingURL=access-list.js.map